import styled from 'styled-components';
import { AccordionButton, AccordionPanel } from '@chakra-ui/react';

const CustomAccordionButton = styled(AccordionButton)`
  padding: 16px 27px;
  margin-top: 1.3em;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors[1300]};
  box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.05);
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.gray200};

  &:hover {
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  }

  .chakra-icon {
    font-size: 24px;
  }

  p {
    font-size: 14px;
    padding: 6px 13px;
    /* border: 1px solid ${({ theme }) => theme.colors[900]};
    color: ${({ theme }) => theme.colors[900]}; */
    font-weight: bold;
    border-radius: 50%;
    margin-right: 16px;
  }

  &[aria-expanded=\"true\"] {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    /* background-color: ${({ theme }) => theme.colors[900]}; */
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray100};
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2) !important;
    & .icon {
      transform: rotate(180deg);
    }
    /* color: ${({ theme }) => theme.colors[1300]}; */
    p {
      /* color: ${({ theme }) => theme.colors[1300]};
      border-color: ${({ theme }) => theme.colors[1300]}; */
    }
    .chakra-icon {
      font-size: 24px;
      /* color: ${({ theme }) => theme.colors[1300]}; */
    }
  }

  .chakra-collapse {
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2) !important;
  }
`;

const CustomAccordionPanel = styled(AccordionPanel)`
  padding: 29px 39px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${({ theme }) => theme.colors[1300]};
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
`;

export { CustomAccordionButton, CustomAccordionPanel };
